import React from 'react'
import { Applestore, Mobile1, Mobile2, Playstore, QR } from '../../assests/ExportImageIcon'

const GetApp = () => {
  return (
    <>
        <section className='getApp paddingCmn'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='getAppInner'>
                            <div className='left'>
                                <img src={Mobile1} className='mob1'/>
                                <img src={Mobile2} className='mob2'/>
                            </div>
                            <div className='right'>
                                <div className='up'>
                                    <div className='title'>Get Your App Now</div>
                                    <p>Search great deals on train, flights, hotels and more on your fingertips</p>
                                </div>
                                <div className='down'>
                                    <img src={QR} />
                                    <div className='storeimg'>
                                        <img src={Playstore} />
                                        <img src={Applestore} />
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default GetApp
